import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, isNavLinkItem } from '../../shared';
import { AccordionContainer, AccordionPanel, AccordionControlLink, AccordionControlButton, Divider, AccordionButtonText, AccordionButtonChevron } from '../../styles/mobileAccordion';
import { VisuallyHidden } from '../../styles/root';

var MobileAccordion = function MobileAccordion(_ref) {
  var head = _ref.head,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      index = _ref.index,
      panel = _ref.panel,
      onClickTab = _ref.onClickTab;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionContainer, {
    "data-test": "".concat(dataTestPrefix, "-accordion-").concat(index)
  }, isNavLinkItem(head) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionControlLink, {
    href: head.useAbsolute ? head.href : envUrl + head.href,
    "data-test": "".concat(dataTestPrefix, "-accordion-link-").concat(index),
    onClick: function onClick(e) {
      var _head$onClick;

      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            element: {
              name: 'nav shortcut',
              type: 'link',
              region_name: 'side nav',
              text: head.text,
              value: head.text.toLowerCase()
            },
            type: 'select'
          }
        }
      }));
      /* istanbul ignore next */

      (_head$onClick = head.onClick) === null || _head$onClick === void 0 ? void 0 : _head$onClick.call(head, e);
    }
  }, isActive && /*#__PURE__*/React.createElement(VisuallyHidden, {
    "data-test": "".concat(dataTestPrefix, "-current-page")
  }, "Current page:"), head.text), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(IconButton, {
    "data-test": "".concat(dataTestPrefix, "-accordion-button-").concat(index),
    "aria-controls": "".concat(dataTestPrefix, "-accordion-panel-").concat(index),
    "aria-expanded": isOpen ? 'true' : 'false',
    onClick: onClickTab,
    screenReaderOnlyText: isOpen ? 'Close menu' : 'Open menu',
    size: "xsmall"
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    role: "presentation",
    pointing: isOpen ? 'up' : 'down',
    size: "xsmall"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionControlButton, {
    "aria-haspopup": "true",
    "data-test": "".concat(dataTestPrefix, "-accordion-button-").concat(index),
    "aria-controls": "".concat(dataTestPrefix, "-accordion-panel-").concat(index),
    "aria-expanded": isOpen ? 'true' : 'false',
    onClick: onClickTab
  }, /*#__PURE__*/React.createElement(AccordionButtonText, null, head.text), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(AccordionButtonChevron, {
    role: "presentation",
    pointing: isOpen ? 'up' : 'down',
    size: "xsmall"
  })))), /*#__PURE__*/React.createElement(AccordionPanel, {
    isOpen: isOpen,
    "data-test": "".concat(dataTestPrefix, "-accordion-panel-").concat(index),
    role: "region"
  }, panel));
};

MobileAccordion.displayName = 'MobileAccordion';
export default MobileAccordion;